import React from 'react'
import { AutoMessageAudit } from '@reggora-app/reggora-conversation-ui'
import api, { API_VERSION, REQUEST_METHOD } from '@app/api'


const fetchAuditData = async (auditId) => {
  const audit = await api(
    `lender/auto-message-audit/${auditId}`,
    API_VERSION.v2
  ).request(REQUEST_METHOD.GET)
  return audit
}


const AutoSentIndicator = ({ message }) => {
  const { autoMessageAuditId, customFieldLabels } = message

  return (
    <AutoMessageAudit
      auditId={autoMessageAuditId}
      fetchAuditData={fetchAuditData}
      customFieldLabels={customFieldLabels}
    />
  )
}

export default AutoSentIndicator
